import clsx from 'clsx';
import PropTypes from 'prop-types';
import React from 'react';

const Content = ({ className, content, asHTML }) => {
  if (asHTML) {
    return (
      <div
        className={clsx('prose prose-lg md:prose-base', className)}
        dangerouslySetInnerHTML={{ __html: content }}
      />
    );
  }

  return <div className={clsx('prose prose-lg md:prose-base', className)}>{content}</div>;
};

Content.propTypes = {
  className: PropTypes.string,
  content: PropTypes.oneOfType([PropTypes.string, PropTypes.node]).isRequired,
  asHTML: PropTypes.bool,
};

Content.defaultProps = {
  className: null,
  asHTML: false,
};

export default Content;
